<div class="objetivos-forzados-container">
    @for (item of planesForzados(); track item) {
        <div class="objetivo-forzado-card">
            <mat-icon class="warning-icon">warning</mat-icon>
            <span class="card-title">{{ item.title }}</span>
            <span class="card-description">{{ "objetivos.componente-forzados" | translate }}</span>
            <span class="card-date">{{ formatDate(item.creationDate) }}</span>
        </div>
    }
</div>
